import { render, staticRenderFns } from "./ArtigosModule.vue?vue&type=template&id=920255e4&scoped=true&"
import script from "./ArtigosModule.vue?vue&type=script&lang=js&"
export * from "./ArtigosModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920255e4",
  null
  
)

export default component.exports